import type { ComponentPropsWithRef } from 'react'
import cn from 'classnames'
import styles from './Drawer.module.css'

export function Items({ ref, className, ...props }: ComponentPropsWithRef<'div'>) {
  return (
    <div
      ref={ref}
      className={cn(styles.items, className)}
      {...props}
    />
  )
}
